module.exports = __webpack_public_path__ + "img/dip-switch.b2fa8909.svg";